import React from "react";
import HomepageStatsBasic from "./homepage-stats-basic";
import HomepageStatsDashboard from "./homepage-stats-dashboard";
import { useGetNumberOfDeimsSites, useGetRecord } from "./hooks";
import { Loader } from "semantic-ui-react";

const HomepageStats = () => {
  const { data: record, isLoading: isRecordLoading } = useGetRecord();
  // const { data: deimsSitesNumber, isLoading: isDeimsSitesLoading } =
  //   useGetNumberOfDeimsSites();
  const deimsSitesNumber = 250;
  const isDeimsSitesLoading = false;
  const isLoading = isRecordLoading || isDeimsSitesLoading;
  if (isLoading) {
    return <Loader />;
  }
  const recordsNumber = record.hits?.total;
  const buckets = record?.aggregations?.metadata_keywords_keywordLabel?.buckets;
  const commonKeywords = Array.isArray(buckets) ? buckets.slice(0, 13) : [];
  return (
    <div className="homepage-stats-container">
      <HomepageStatsBasic
        deimsSitesNumber={deimsSitesNumber}
        recordsNumber={recordsNumber}
      />
      <HomepageStatsDashboard commonKeywords={commonKeywords} />
    </div>
  );
};

export default HomepageStats;
